 let createOrderApi = {
   name: "创建订单",
   updateTime: "2020-05-30 10:00:00",
   methods: 'post',
   url: 'ygw.api.order.create',
   request: [{
       params: 'distributionType',
       type: "Number",
       required: true,
       length: 1,
       description: {
         text: '配送方式',
         value: ['0:邮寄', '1:到店自提', '2:送货上门']
       },
       example: '0'
     }, {
       params: 'express',
       type: "String",
       required: false,
       length: 10,
       description: {
         text: '邮寄方式快递公司选择',
         value: ['SF:顺丰', 'JD:京东', 'distributionType为0时必填']
       },
       example: 'SF'
     }, {
       params: '+recipient',
       type: "Object",
       required: false,
       length: 300,
       description: {
         text: '收货人信息',
         value: ['配送方式不为1时必填']
       },
       example: 'md5值'
     }, {
       params: '└provinceCode',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '收货地址省编码',
         value: []
       },
       example: 440000
     }, {
       params: '└cityCode',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '收货地址市编码',
         value: []
       },
       example: 440300
     }, {
       params: '└areaCode',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '收货地址区编码',
         value: []
       },
       example: 440303
     }, {
       params: '└detailAddress',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '详细收货地址',
         value: []
       },
       example: '华强广场大厦16HI号'
     }, {
       params: '└recipientName',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '收货人名称',
         value: []
       },
       example: '张山'
     }, {
       params: '└recipientPhone',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '收货人名称',
         value: []
       },
       example: '13888888888'
     },
     {
       params: 'store',
       type: "String",
       required: false,
       length: 10,
       description: {
         text: '到店自提方式门店选择',
         value: ['HQB:华强北门店 (distributionType为1时必填)']
       },
       example: 'HQB'
     }, {
       params: '+linkman',
       type: "Object",
       required: true,
       length: 10,
       description: {
         text: '下单联系人信息',
         value: []
       },
       example: ''
     }, {
       params: '└linkmanName',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '张山',
         value: []
       },
       example: ''
     },
     {
       params: '└linkmanPhone',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '下单联系人电话',
         value: []
       },
       example: ''
     },
     {
       params: 'isInvoice',
       type: "Number",
       required: true,
       length: '1',
       description: {
         text: '是否开票:',
         value: ['0:不开票', '1:开票']
       },
       example: '0'
     }, {
       params: '+goodsList',
       type: "Object",
       required: true,
       length: '',
       description: {
         text: '产品清单列表',
         value: []
       },
       example: ''
     },
     {
       params: '└goodsCode',
       type: "String",
       required: true,
       length: '',
       description: {
         text: '油柑编码',
         value: []
       },
       example: '04SUP000001'
     },
     {
       params: '└quantity',
       type: "Number",
       required: true,
       length: '32',
       description: {
         text: '购买数量(pcs)',
         value: []
       },
       example: '300'
     },
     {
       params: 'orderRemark',
       type: "String",
       required: true,
       length: '300',
       description: {
         text: '订单备注信息',
         value: []
       },
       example: '麻烦放到仓库门口'
     }
   ],
   reseponse: [{
     params: 'productAmount',
     type: "Number",
     required: true,
     length: '',
     description: {
       text: '商品价格',
       value: []
     },
     example: '24.80'
   }, {
     params: 'payAmount',
     type: "Number",
     required: true,
     length: '',
     description: {
       text: '支付价格',
       value: []
     },
     example: '36.80'
   }, {
     params: 'expressAmount',
     type: "Number",
     required: true,
     length: '',
     description: {
       text: '快递费',
       value: []
     },
     example: '12.00'
   }, {
     params: 'totalAmount',
     type: "Number",
     required: true,
     length: '',
     description: {
       text: '订单价格',
       value: []
     },
     example: '36.80'
   }],
   code: {
     sign: "94c0d23036d9ef73c551c8c49497d802",
     appId: "9527",
     method: "ygw.api.order.create",
     params: JSON.stringify({
       distributionType: 0,
       express: "JD",
       recipient: {
         provinceCode: 440000,
         cityCode: 440000,
         areaCode: 440303,
         detailAddress: "华强广场大厦16HI号",
         recipientName: "张山",
         recipientPhone: "13888888888"
       },
       linkman: {
         linkmanName: "小王",
         linkmanPhone: "13088887777"
       },
       goodsList: [{
         goodsCode: '04SUP000001',
         quantity: 10000
       }],
       orderRemark: '麻烦放到仓库门口'
     })
   }
 }

 export {
   createOrderApi
 }